export const ADMIN_URL = process.env.REACT_APP_API_ENDPOINT_ADMIN + '/admin';
export const AUTH_URL = process.env.REACT_APP_API_ENDPOINT_AUTH + '/auth';
// export const MEMBER_URL = process.env.REACT_APP_API_ENDPOINT_MEMBER + '/member';
//export const CLAIM_URL = process.env.REACT_APP_API_ENDPOINT_CLAIM + '/claim';
export const ORDER_URL = process.env.REACT_APP_API_ENDPOINT_ORDER + '/order';
export const API_KEY = process.env.REACT_APP_API_KEY;
